import { Dropdown } from 'react-bootstrap';

import { useAppDispatch, useAppSelector } from '@/store/hooks.ts';
import { selectTabIds, selectTabName } from '@/store/tabs/selectors.ts';
import { changeActiveTab } from '@/store/tabs/slice.ts';

export function WorkspacePicker() {
  const tabIds = useAppSelector(selectTabIds);
  const dispatch = useAppDispatch();

  function onSelectTab(tabId: string) {
    dispatch(changeActiveTab({ tabId }));
  }

  return (
    <Dropdown>
      <Dropdown.Toggle variant="flat-secondary" className="btn-icon btn-lg" />
      <Dropdown.Menu>
        {tabIds.map((tabId) => (
          <Item key={tabId} tabId={tabId} onClick={() => onSelectTab(tabId)} />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

function Item(props: { onClick: () => void; tabId: string }) {
  const workspaceName = useAppSelector((state) => selectTabName(state, props.tabId));

  return <Dropdown.Item onClick={props.onClick}>{workspaceName}</Dropdown.Item>;
}
